import React from 'react'
import ImageWithBasePath from '../core/common/imageWithBasePath'
import { Link } from 'react-router-dom';
import { all_routes } from './router/all_routes';


interface BannerProps {
    apiValues: any;
}



const Subscribe: React.FC<BannerProps> = ({ apiValues }) => {

    const bgImageUrl = "/assets/img/palani-bg-gray.jpg"; // Replace with actual image URL
    const route = all_routes;


    return (
        <>
            {/* subscribe section */}
            <div
                className="subsribe-section  bg-cover bg-center"
                style={{
                    backgroundImage: `url(${bgImageUrl})`,
                }}
            >
                <div className="container position-relative">
                    <ImageWithBasePath
                        src="assets/img/icons/banner-icon-03.svg"
                        alt="img"
                        className="img-fluid bg-05  d-none d-lg-flex"
                    />
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contact-section">
                                <div className="mb-4 aos">
                                    <h2 className="text-[#1D1753] mb-1">
                                        {apiValues?.belowBanner?.title}
                                    </h2>
                                    <p className="text-gray-600 fs-16">
                                        {apiValues?.belowBanner?.description}

                                    </p>
                                </div>
                                {/* <form action="#" className="subcribe-form">
                                    <span>
                                        <i className="isax isax-message-text" />
                                    </span>
                                    <input
                                        type="email"
                                        placeholder="Email Address"
                                        className="form-control"
                                    /> */}
                                <Link to={route.Unlock}
                                    type="submit"
                                    className="bg-red-600 hover:bg-red-700 text-white py-3 px-5 text-center rounded-full "
                                >
                                    {apiValues?.belowBanner?.buttonText}

                                </Link>
                                {/* </form> */}
                            </div>
                        </div>
                        <div className="col-lg-6 position-relative">
                            <ImageWithBasePath
                                src="assets/img/bg/subscribe-bg-01.png"
                                alt="img"
                                className="img-fluid bg-01 d-none d-lg-flex aos"

                            />
                            <ImageWithBasePath
                                source={apiValues?.belowBanner?.imageUrl}
                                alt="img"
                                className="d-none bg-02 d-lg-flex w-[300px] h-[300px]"

                            />
                            <ImageWithBasePath
                                src="assets/img/icons/subscribe-icon-02.svg"
                                alt="img"
                                className="img-fluid bg-03 d-none d-lg-flex"
                            />
                            <ImageWithBasePath
                                src="assets/img/icons/subscribe-icon-01.svg"
                                alt="img"
                                className="img-fluid bg-04 d-none d-lg-flex"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* /subscribe section */}
        </>

    )
}

export default Subscribe
